import React from 'react';
import { useDispatch } from 'react-redux';
import Wrapper from './TitleAndNew.Styles';
import { Button, Typography, Icon } from 'antd';
import { REQUEST_GET_ALL_PROJECTS_FOR_ADMIN } from '../../Redux/constants/constants';
const { Title } = Typography;

const TitleAndNew = ({ titleText, buttonText, actionType }) => {
  const dispatch = useDispatch();
  return (
    <Wrapper>
      <Title level={2}>{titleText}</Title>
      {buttonText && (
        <Button
          type="primary"
          onClick={() => dispatch({ type: actionType })}
          // onClick={() => dispatch({ type: REQUEST_GET_ALL_PROJECTS_FOR_ADMIN })}
        >
          <Icon type="plus" />
          {buttonText}
        </Button>
      )}
    </Wrapper>
  );
};

export default TitleAndNew;
